module.exports = __webpack_public_path__ + "static/media/og-img.3fb953aa.jpg";